import 'shared/components/cart/style.scss';

import React, { Fragment } from 'react';
import Text from 'components/ui/text';
import PromoIcon from 'images/icons/promo-outline-black.svg?react-svg';

export default function OrderProductsListItem({ item, engraving }) {
  return (
    <li className="cart-item">
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <img src={item.image} className="cart-item__thumbnail inline-block" />
        <div style={{ flex: 1 }} className="inline-block">
          <Text weight="bold">
            {item.title} x {item.quantity}
          </Text>
          <div>{item.subtitle}</div>
          <div>{item.volume}</div>
        </div>
        <div className="inline-block text-right">
          {item.subtotal ? (
            <Fragment>
              <Text success size="xs" weight="med">
                <div className="inline-block promo-icon">
                  <PromoIcon />
                </div>
                ${item.subtotal.toFixed(2)}
              </Text>
              <Text className="strikethrough" size="xs">
                ${(item.discount_price * item.quantity).toFixed(2)}
              </Text>
            </Fragment>
          ) : (
            <Text size="xs" weight="med">
              {item.discount_price &&
                `$${(item.discount_price * item.quantity).toFixed(2)}`}
            </Text>
          )}
        </div>
      </div>

      {!!engraving && (
        <div className="cart-item__engraving">
          <hr className="light" />
          <Text className="right" weight="med" size="xs">
            {engraving.discount_price &&
              `(+$${engraving.discount_price.toFixed(2)})`}
          </Text>
          <div className="text-bold">Engraving</div>
          {engraving.meta &&
            engraving.meta.line_1 && <div>{engraving.meta.line_1}</div>}
          {engraving.meta &&
            engraving.meta.line_2 && <div>{engraving.meta.line_2}</div>}
          {engraving.meta &&
            engraving.meta.line_3 && <div>{engraving.meta.line_3}</div>}
        </div>
      )}
    </li>
  );
}
